import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

export interface CollapsibleSectionThemeProps {
  isSectionOpen: boolean;
}

const styles: ComponentStylesProps<CollapsibleSectionThemeProps> = {
  title: ({ isSectionOpen }) => ({
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    fontWeight: 700,
    letterSpacing: '0.05rem',
    textTransform: 'uppercase',
    textAlign: 'center',
    padding: '1.5rem 0',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    margin: isSectionOpen ? '0 0 5rem' : '0 0 3rem',
    width: '100%',
    borderRadius: '1rem 1rem 0 0',
  }),
  stickyTitle: ({ isSectionOpen }) => ({
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 10,
    boxShadow: isSectionOpen ? boxShadows.light[4] : 'none',
  }),
  section: {
    opacity: 1,
    transition: '0.3s ease',
    overflow: 'hidden',
  },
  closedSection: {
    opacity: 0,
    maxHeight: 0,
    transition: '0.3s ease ',
  },
  sectionGuideline: {
    margin: 0,
    textAlign: 'center',
    fontSize: '1.4rem',
    color: colors.neutral[700],
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
